
<template>
  <v-container class="ma-0">
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Τιμολογηθέντα Ανταλλακτικά</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="lineItems"
      :search="search"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      show-group-by
      :expanded.sync="expanded"
    >
<template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="'/invoice/details/'+item.InvoiceId"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.UnitPrice="{ item }">
       {{ tocurr(item.UnitPrice) }}
    </template>
     <template v-slot:item.netvalue="{ item }">
       {{ tocurr(item.NetValue) }}
    </template>
    <template v-slot:item.totalvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*1.24) }}
    </template>
    <template v-slot:item.vatvalue="{ item }">
       {{ tocurr(item.litem.price*item.litem.qty*0.24) }}
    </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.ItemCode }}
      </td>
    </template>



    </v-data-table>
  </v-card>
    </v-container>
</template>


<script>

//import QuoteCard from '../../components/QuoteCard.vue';

export default {
  components: {
 //   QuoteCard
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: '',
      customer_id: this.$route.params.gid,
      lineItems: [],
      headers: [
          {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            groupable: false,
            value: 'Id',
            width: '10%',
          },
          { text: 'Τιμολόγιο', value: 'InvoiceId', width: '10%' },
          { text: 'Γραμμή', value: 'Line', width: '10%' },
          { text: 'Κωδικός', value: 'ItemCode', width: '10%' },
          { text: 'Περιγραφή', value: 'ItemDesc' },
        { text: 'Ποσότητα', value: 'Qty', align: 'center', groupable: false  },
        { text: 'Μονάδα Μέτρησης', value: 'ItemUnit', align: 'center', groupable: false  },
        { text: 'Τιμή', value: 'UnitPrice', align: 'end', groupable: false  },
        // { text: 'Καθαρή αξία', value: 'NetValue', align: 'end', groupable: false  },
        //  { text: 'ΦΠΑ', value: 'vatvalue', align: 'end', groupable: false },
        //  { text: 'Συνολο', value: 'totalvalue', align: 'end', groupable: false},
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand', groupable: false },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/customers/invoice-lines/'+this.$route.params.id);
        //console.log(response);
        this.lineItems = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  }
}
</script>
